import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import projectKeys from './keyFactory';

const GetProjectEstimates = graphql(`
  query GetProjectEstimates($projectId: ID!) {
    projectById(id: $projectId) {
      id
      reference
      pipeline {
        publicId
        name
      }
      customer {
        id
        contacts {
          publicId
          name
          email
          isPrimary
        }
      }
      estimates {
        ...EstimateBuilderEstimate
      }
    }
  }
`);

const useGetProjectEstimates = (projectId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.estimates(projectId!),
    queryFn: () => {
      return gqlClient.request(GetProjectEstimates, {
        projectId: projectId!,
      });
    },
    // Prevents newly mounted observers (e.g. SectionEditor on the first add)
    // from racing a refetch against an in-flight optimistic mutation and
    // clobbering the optimistic write with pre-mutation server data.
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
  return {
    project: data?.projectById,
    data,
    ...rest,
  };
};

export default useGetProjectEstimates;
